import { BudgetTypes, CheckOutWarningType } from '../enums';
import { CustomerInvoicingAddressModel } from './Customers';
import { ValidationError } from './Errors';
import { PaymentMethodModel } from './PaymentMethods';
import {
  DefaultProductDetailsModel,
  ProductCalculationOutputModel,
} from './Product';
import { TagModel } from './Tag';

export interface CartItem {
  cartItemId: number;
  quantity: number;
  isRecurring: boolean;
  price: ProductCalculationOutputModel;
  product: DefaultProductDetailsModel;
}

export interface CartSummaryModel {
  cartTotal: number;
  paidFromBudget: number;
  paidFromContribution: number;
  salaryTaxes: number;
  budgetTaxes: number;
  hasTemporaryDeactivatedProducts: boolean;
  products: ProductSummaryModel[];
  paymentMethods: PaymentMethodModel[];
  validationErrors: ValidationError[];
  customerInvoicingAddress?: CustomerInvoicingAddressModel;
  selectedCheckoutMethods: BudgetTypes[];
  isSalaryDeductionSelected: boolean;
  cashbackDiscount: number;
}

export interface ProductSummaryModel {
  cartItemId: number;
  productId: number;
  quantity: number;
  isRecurring: boolean;
  recurringSummary: RecurringSummaryModel | null;
  recurringLabel?: string;
  useBenefitBudget: boolean;
  price: number;
  paidFromBudget: number;
  paidFromContribution: number;
  cashbackDiscount: number;
  budgetTaxes: number;
  salaryTaxes: number;
  budgetType: BudgetTypes;
  imagePath?: string;
  name?: string;
  isFavorite: boolean;
  isBenefitInKind: boolean;
  options: string;
  tags?: TagModel[];
  budgetTypeMessage?: string;
  budgetTypeInfo?: string;
  canUseBenefitBudget: boolean;
  abortController?: AbortController;
}

export enum FrequencyType {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  Yearly = 3,
}

export interface RecurringSummaryModel {
  frequency: FrequencyType;
  duration: number;
  monthStart: number;
  yearStart: number;
  monthEnd: number;
  yearEnd: number;
}

export interface CanCheckOutModel {
  warningType: CheckOutWarningType | null;
  value: boolean;
}
